import { Extension, Node, mergeAttributes } from '@tiptap/core';
import { Image } from '@tiptap/extension-image';
export { default } from '@tiptap/extension-table';
export { default as default2 } from '@tiptap/extension-table-row';
export { default as default3 } from '@tiptap/extension-table-header';
export { default as default4 } from '@tiptap/extension-table-cell';

// src/extensions/InsertMarkdownExtension.ts
var insertMarkdownExtension = Extension.create({
  name: "insertMarkdown",
  addOptions() {
    return {
      parser: null
    };
  },
  addCommands() {
    return {
      insertMarkdown: (mdContent, options) => ({ chain }) => {
        const parsedNode = this.options.parser.parse(mdContent);
        const content = parsedNode.toJSON().content;
        if (!content) return;
        const isSingleLine = content.length === 1;
        const isParagraph = content[0].type === "paragraph";
        if ((options == null ? void 0 : options.inlineSingleParagraph) && isParagraph && isSingleLine)
          return chain().insertContent(content[0].content).run();
        return chain().insertContent(content).run();
      }
    };
  }
});
var mentionDocExtension = Node.create({
  name: "mentionDoc",
  bubbleMenu: false,
  inline: true,
  group: "inline",
  atom: true,
  selectable: false,
  addAttributes() {
    return {
      id: {
        default: null
      }
    };
  },
  parseHTML() {
    return [
      {
        tag: "mentionDoc"
      },
      {
        tag: "mentiondoc"
      }
    ];
  },
  renderHTML({ HTMLAttributes }) {
    return ["mentionDoc", mergeAttributes(HTMLAttributes, {})];
  },
  addCommands() {
    return {
      mentionDoc: ({ range, id }) => ({ chain }) => {
        return chain().insertContentAt(range, [
          {
            type: "mentionDoc",
            attrs: { id }
          },
          {
            type: "text",
            text: " "
          }
        ]).run();
      }
    };
  }
});
var imageExtension = Image.extend({
  group: "block",
  addAttributes() {
    var _a;
    return {
      ...(_a = this.parent) == null ? void 0 : _a.call(this),
      width: {
        default: null,
        parseHTML: (element) => element.getAttribute("width")
      },
      height: {
        default: null,
        parseHTML: (element) => element.getAttribute("height")
      },
      id: {
        default: null
      }
    };
  },
  parseHTML() {
    var _a;
    return [
      ...((_a = this.parent) == null ? void 0 : _a.call(this)) || [],
      {
        tag: "img[id]",
        attrs: {
          width: {
            default: null
          },
          height: {
            default: null
          }
        }
      }
    ];
  }
});
var mentionTranscriptionExtension = Node.create({
  name: "mentionTranscription",
  bubbleMenu: false,
  inline: true,
  group: "inline",
  atom: true,
  selectable: false,
  addAttributes() {
    return {
      parentDocId: {
        default: null
      }
    };
  },
  parseHTML() {
    return [
      {
        tag: "mentionTranscription"
      },
      {
        tag: "mentiontranscription"
      }
    ];
  },
  renderHTML({ HTMLAttributes }) {
    return ["mentionTranscription", mergeAttributes(HTMLAttributes, {})];
  },
  addCommands() {
    return {
      mentionTranscription: ({ range, parentDocId }) => ({ chain }) => {
        return chain().insertContentAt(range, [
          {
            type: "mentionTranscription",
            attrs: { parentDocId }
          },
          {
            type: "text",
            text: " "
          }
        ]).run();
      }
    };
  }
});

export { imageExtension, insertMarkdownExtension, mentionDocExtension, mentionTranscriptionExtension };
